import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export const SITUACAO_DOWNLOAD = {
  LIBERADO: 'liberado',
  SEM_LOGIN: 'semLogin',
  OUTRO_CLIENTE: 'outroCliente',
  INDISPONIVEL: 'indisponivel',
  FALHA: 'falha',
};

const situacaoPorStatus = {
  401: SITUACAO_DOWNLOAD.SEM_LOGIN,
  403: SITUACAO_DOWNLOAD.OUTRO_CLIENTE,
  404: SITUACAO_DOWNLOAD.INDISPONIVEL,
};

// Sem o cliente `api`: o interceptor dele alerta em 403/404 e manda ao login sem guardar a rota de volta.
export const resolverDownload = id =>
  trackPromise(
    axios
      .get(`${process.env.REACT_APP_CADASTROS_API_URL}/downloads/${encodeURIComponent(id)}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('autenticacao.token')}` },
      })
      .then(resp => ({ situacao: SITUACAO_DOWNLOAD.LIBERADO, url: resp.data.url }))
      .catch(erro => ({ situacao: situacaoPorStatus[erro?.response?.status] || SITUACAO_DOWNLOAD.FALHA })),
  );
